import {
	dateFormatter,
	dateTimeFormatter, dollarFormatter, numberFormatter
} from "../../gridFormatters";
import { wtAvg } from "../../math";

export const cloudTrends = [
	{
		"field": "collection_date",
		"headerName": "Collection Date",
		"cellRenderer": dateFormatter
	},
	{
		"field": "device_type_code",
		"headerName": "Device Type Code",
	},
	{
		"field": "disk_used",
		"headerName": "Disk Used",
		"type": "numericColumn",
		"cellRenderer": numberFormatter,
		"aggFunc": "sum",
		"filter": "agNumberColumnFilter",
	},
	{
		"field": "total_disk",
		"headerName": "Total Disk",
		"type": "numericColumn",
		"cellRenderer": numberFormatter,
		"aggFunc": "sum",
		"filter": "agNumberColumnFilter",
	},
	{
		"field": "disk_mbps",
		"headerName": "Disk Mbps",
		"type": "numericColumn",
		"cellRenderer": numberFormatter,
		"aggFunc": "sum",
		"filter": "agNumberColumnFilter",
	},
	{
		"field": "disk_iops",
		"headerName": "Disk Iops",
		"type": "numericColumn",
		"cellRenderer": numberFormatter,
		"aggFunc": "sum",
		"filter": "agNumberColumnFilter",
	},
	{
		"field": "vcpu",
		"headerName": "vCPU",
		"type": "numericColumn",
		"cellRenderer": numberFormatter,
		"aggFunc": "sum",
		"filter": "agNumberColumnFilter",
	},
	{
		"field": "cpu_used",
		"headerName": "CPU Used",
		"type": "numericColumn",
		"cellRenderer": numberFormatter,
		"aggFunc": "sum",
		"filter": "agNumberColumnFilter",
	},
	{
		"field": "total_cpu",
		"headerName": "Total CPU",
		"type": "numericColumn",
		"cellRenderer": numberFormatter,
		"aggFunc": "sum",
		"filter": "agNumberColumnFilter",
	},
	{
		"field": "memory_used",
		"headerName": "Memory Used",
		"type": "numericColumn",
		"cellRenderer": numberFormatter,
		"aggFunc": "sum",
		"filter": "agNumberColumnFilter",
	},
	{
		"field": "free_memory",
		"headerName": "Free Memory",
		"type": "numericColumn",
		"cellRenderer": numberFormatter,
		"aggFunc": "sum",
		"filter": "agNumberColumnFilter",
	},
	{
		"field": "total_memory",
		"headerName": "Total Memory",
		"type": "numericColumn",
		"cellRenderer": numberFormatter,
		"aggFunc": "sum",
		"filter": "agNumberColumnFilter",
	},
	{
		"field": "iops_capacity",
		"headerName": "Iops Capacity",
		"type": "numericColumn",
		"cellRenderer": numberFormatter,
		"aggFunc": "sum",
		"filter": "agNumberColumnFilter",
	},
	{
		"field": "latency",
		"headerName": "Latency",
		"type": "numericColumn",
		"cellRenderer": numberFormatter,
		"aggFunc": p => wtAvg(p, "latency", "disk_iops"),
		"filter": "agNumberColumnFilter",
	},
	{
		"field": "total_cost",
		"headerName": "Total Cost",
		"type": "numericColumn",
		"cellRenderer": dollarFormatter,
		"aggFunc": "sum",
		"filter": "agNumberColumnFilter",
	},
]
